var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelGoogleplusSm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 11,
  viewBox: "0 0 16 11",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M5.082 0c1.317 0 2.517.5 3.42 1.323-1.064 1.004-1.03 1.064-1.447 1.482-.522-.432-1.092-.742-1.973-.742-1.668 0-2.969 1.351-2.969 3.019 0 1.667 1.301 3.019 2.969 3.019 1.647 0 2.317-.71 2.747-2.016l-.892.001h-.863l-.161.001-.78.001h-.051V4.075h4.88c.34 2.436-.685 6.089-4.88 6.089A5.082 5.082 0 0 1 5.082 0m9.157 2.415v1.761H16v1.258h-1.761v1.811h-1.258V5.434H11.17V4.176h1.811v-1.76z"
})));
export default SvgChannelGoogleplusSm;